import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";

@Component({
	components: {}
})
export default class Progress extends Vue {
	@Prop() visible!: boolean;
}
